export const OPENAI_ACTION_TYPE = {
  generateTaxPlan: "generateTaxPlan",
  generateTaxPlanIdle: "generateTaxPlanIdle",
  getTaxPlan: 'getTaxPlan',
  deleteSavedTaxPlan:"deleteSavedTaxPlan",
  getTaxPlanIdle: 'getTaxPlanIdle',
  getTaxPlanHtml: 'getTaxPlanHtml',
  getTaxPlanHtmlIdle: 'getTaxPlanHtmlIdle',
  resetTaxPlanGenerator: 'resetTaxPlanGenerator',
  getTaxPlanStrategies: "getTaxPlanStrategies",
  getTaxPlanStrategiesIdle: "getTaxPlanStrategiesIdle",
  getTaxPlanJson: "getTaxPlanJson",
  getTaxPlanJsonIdle: "getTaxPlanJsonIdle",
};